export default {"src":"/_next/static/media/registration-complete.15fa36dc.svg","height":271,"width":395,"blurWidth":0,"blurHeight":0};